<template>
  <v-layout>
    <v-flex>
      <v-card id="dc5043bd">
        <v-card-title>
          {{ $t('userList') }}
          <v-spacer></v-spacer>
          <v-text-field id="c20d8ffd" v-model="search" :label="$t('search')" append-icon="mdi-magnify" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table
          id="6f08f8fc"
          must-sort
          :search="search"
          :headers="headers"
          :items="userList"
          :options.sync="pagination"
          :server-items-length="totalItems"
          :loading="loading"
          :loading-text="$t('dataTable.loadingPleaseWait')"
          :no-data-text="$t('dataTable.noDataAvailable')"
          :no-results-text="$t('dataTable.noMatchingRecordsFound')"
          :footer-props="{
            'items-per-page-text': $t('dataFooter.itemsPerPage'),
            'page-text': $t('dataFooter.pageText'),
            'items-per-page-options': [10,25,50]
          }"
        >
          <template v-slot:item.roles="{ item }">
            <v-chip v-for="role in item.roles" :key="role">
              {{ role }}
            </v-chip>
          </template>
          <template v-if="isSo" v-slot:item.action="{ item }">
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-btn :id="setTableItemOperationDynamicId('8b2841c4', item.username)" icon :to="'users/' + item.username + '/edit'" v-on="on">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('edit') }}</span>
            </v-tooltip>
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-btn :id="setTableItemOperationDynamicId('c97f80be', item.username)" icon v-on="on" @click="deleteUser(item.username)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('delete') }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card>

      <fab-button v-if="isSo" id="2aa43559" tooltip-text="add" to="users/add" />
    </v-flex>
  </v-layout>
</template>

<script>
import users from '@/api/users'
import debounce from 'lodash.debounce'
import Role from '../../Role'
import { showToastSuccess, showToastError, showConfirmationDialog } from '../../event-bus'
import { mapGetters } from 'vuex'
import FabButton from '../../components/FabButton.vue'

export default {
  name: 'UserList',

  components: {
    'fab-button': FabButton
  },

  data() {
    return {
      search: null,
      pagination: {
        sortBy: ['username']
      },
      userList: [],
      totalItems: 0,
      loading: false,
      headers: [
        {
          text: this.$t('username'),
          align: 'left',
          value: 'username'
        },
        {
          text: this.$t('roles'),
          value: 'roles',
          sortable: false
        },
        {
          text: this.$t('actions'),
          value: 'action',
          sortable: false
        }
      ]
    }
  },

  computed: {
    ...mapGetters(['hasRole']),
    isSo() {
      return this.hasRole(Role.SO)
    }
  },

  watch: {
    search() {
      this.loading = true
      this.searchUserWatcher()
    },
    pagination() {
      this.searchUsers()
    }
  },

  methods: {
    async searchUsers() {
      this.loading = true
      try {
        let pageRequest = {
          'page-num': this.pagination.page,
          'page-size': this.pagination.itemsPerPage,
          'sort-field': this.pagination.sortBy[0],
          'sort-order': this.pagination.sortDesc[0] ? 'desc' : 'asc'
        }
        let page = await users.listUsers(this.search, pageRequest)
        this.userList = page.content
        this.totalItems = page.total
      } catch (error) {
        showToastError(this.$t('toastMessage.errorWhileRetrievingData'))
      } finally {
        this.loading = false
      }
    },

    searchUserWatcher: debounce(function() {
      this.searchUsers()
    }, 500),

    async deleteUser(name) {
      let conf = await showConfirmationDialog(this.$t('confirmation'), this.$t('dialog.text.deleteItem'))
      if (!conf.confirmedValue) {
        return
      }

      try {
        await users.deleteUser(name)
        this.searchUsers()
        showToastSuccess(this.$t('toastMessage.succesfullyDeleted'))
      } catch (error) {
        showToastError(this.$t('toastMessage.errorWhileRetrievingData'))
      }
    }

  }
}
</script>
